module.exports = __webpack_public_path__ + "img/Ptuapp4.fb2f9591.png";